<template>
  <div class="page">
    <main class="page-content main">
      <div class="terms-of-use">
        <ol class="terms-of-use__list">
          <li class="terms-of-use__item">
            <h4 class="terms-of-use__item-title">Правила пользования ресурсом Banhammer.ai</h4>
            <p>
              Данный документ содержит правила пользования сайтом Banhammer.ai. Авторизуясь в
              сервисе, вы соглашаетесь с данными условиями.
            </p>
            <p>
              Контактный адрес администрации сайта:
              <a href="feedback@banhammer.ai">feedback@banhammer.ai</a>
            </p>
          </li>
          <li class="terms-of-use__item">
            <h4 class="terms-of-use__item-title">Сведения о сервисе Banhammer.ai</h4>
            <p>
              Banhammer.ai — веб-сервис, предоставляющий анализ статистики рекламных кампаний
              пользователя в учетной записи Яндекс.Директ, а также рекомендации по оптимизации
              рекламных кампаний, в частности по исключению из рекламных кампаний мест размещения
              (рекламных площадок). Владельцы ресурса Banhammer.ai обязуются собирать данные о
              рекламных кампаниях пользователя только в этих целях и не посягать на интеллектуальную
              собственность пользователя, не передавать полученные данные третьим лицам, включая, но
              не ограничиваясь, текстами рекламных объявлений, запросами на поиске, минусами на
              поиске и данными о конверсиях в рекламном аккаунте пользователя.
            </p>
          </li>
          <li class="terms-of-use__item">
            <h4 class="terms-of-use__item-title">Содержимое сайта Banhammer.ai</h4>
            <p>
              Все содержимое сайта принадлежит его владельцам. Администрация сайта не имеет
              отношения к компании Яндекс. Товарные знаки Яндекс и Яндекс.Директ принадлежат ООО
              «Яндекс».
            </p>
          </li>
          <li class="terms-of-use__item">
            <h4 class="terms-of-use__item-title">Условия предоставления сервиса</h4>
            <p>
              Сервис Banhammer.ai предоставляется по принципу «как есть», то есть без гарантий
              качества и пригодности сервиса для каких-либо явных или подразумеваемых целей. Сервис
              не гарантирует, что будет работать беспрерывно и безошибочно. Сервис оставляет за
              собой право в любое время приостановить предоставление услуг пользователям без
              объяснения причин.
            </p>
          </li>
          <li class="terms-of-use__item">
            <h4 class="terms-of-use__item-title">Ограничение ответственности</h4>
            <p>
              Сервис Banhammer.ai не несет ответственность за прямые или косвенные убытки, упущенную
              выгоду, моральный вред, понесенные пользователем или третьими лицами (владельцами
              рекламных площадок) в связи с использованием сервиса или невозможностью его
              использования, в том числе, но, не ограничиваясь:
            </p>

            <ul class="terms-of-use__list terms-of-use__list--ul">
              <li class="terms-of-use__item terms-of-use__item--ul">
                техническими перебоями в работе сервиса;
              </li>
              <li class="terms-of-use__item terms-of-use__item--ul">
                снижением эффективности рекламных кампаний пользователя из-за некорректно настроенных счетчиков конверсии;
              </li>
              <li class="terms-of-use__item terms-of-use__item--ul">
                попаданием рекламной площадки в глобальный черный список из-за плохой статистики
                конверсий на большой выборке рекламных аккаунтов.
              </li>
            </ul>
          </li>
          <li class="terms-of-use__item">
            <h4 class="terms-of-use__item-title">Перепродажа услуг сервиса</h4>
            <p>
              Пользователь не вправе перепродавать услуги сервиса или пытаться взымать плату с
              третьих лиц за продукты его работы (в частности, за глобальные чёрные списки рекламных
              площадок) без письменного разрешения от владельцев сервиса.
            </p>
          </li>
          <li class="terms-of-use__item">
            <h4 class="terms-of-use__item-title">Изменение условий пользования сервисом</h4>
            <p>
              Владельцы сайта Banhammer.ai обязуются сообщать пользователям обо всех изменениях в
              данном соглашении.
            </p>
          </li>
        </ol>

        <div class="terms-of-use__date-publications">Дата публикации: 20 февраля 2021 г.</div>

        <router-link :to="{ name: 'home' }">Вернуться на главную</router-link>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'TermsOfUse',
  created() {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="scss">
@import "../assets/style/scss/landing/termsOfUse";
</style>
